import { Box, Flex, GridItem, Spacer, Stack } from "@chakra-ui/react";
import React from "react";

import { isFreeItem } from "components/Basket/utils/freeItemCheck";
import type { ProductListVariants } from "components/BasketLists/ProductList/ProductList";
import type { BasketPricingType, ItemType, Maybe } from "@shared/graphql.types";

import { MembershipPricing } from "./MembershipPricing";
import { MembershipDescription } from "./MembershipDescription";
import { getMembershipVisualUrl } from "../Card.utils";
import { CardContainer } from "../CardContainer";
import { CardImage } from "../CardImage";
import { RemoveFromBagButton } from "../RemoveFromBagButton";

type Props = {
  item: ItemType;
  hasCloseButton?: boolean;
  variant?: ProductListVariants;
  hideRemoveButton?: boolean;
  pricing: Maybe<BasketPricingType> | undefined;
  onRemoveBasketItem: (item: ItemType) => Promise<void>;
};

export const MembershipCard: React.FC<Props> = ({
  item,
  hasCloseButton = true,
  hideRemoveButton,
  pricing,
  onRemoveBasketItem
}) => {
  const imageUrl = getMembershipVisualUrl(item?.membership?.visual);
  const itemIsFree = isFreeItem(item);

  const handleRemove = async () => {
    await onRemoveBasketItem(item);
  };

  if (!pricing) return null;

  return (
    <CardContainer cardKey="membership-card">
      <GridItem>
        <CardImage
          item={item}
          src={imageUrl}
          alt={item?.membership?.visual?.altTag}
          imgHeight="90px"
        />
      </GridItem>
      <GridItem px={0.5}>
        <Flex>
          <Box marginBottom="10px" minHeight="45px">
            <MembershipDescription item={item} />
          </Box>
          <Spacer />
          {!hideRemoveButton && (
            <Box display="flex">
              {hasCloseButton && !itemIsFree && (
                <RemoveFromBagButton removeItem={handleRemove} />
              )}
            </Box>
          )}
        </Flex>
        <Stack
          display="flex"
          flexDirection="row"
          css={{
            "@media (max-width: 374px)": {
              marginTop: "0 !important",
              flexDirection: "column"
            }
          }}
        >
          <Box
            flex="1"
            display="flex"
            mb={0}
            mt={{
              base: "42px !important",
              md: "0 !important"
            }}
            css={{
              "@media (max-width: 374px)": {
                marginTop: "0 !important"
              }
            }}
          >
            <MembershipPricing item={item} pricing={pricing} />
          </Box>
        </Stack>
      </GridItem>
    </CardContainer>
  );
};
